// src/components/Modal.js
import React from "react";
import "./Modal.css";

import blueSunLeft from "../assets/corner/blue-sun-left.png";
import blueSunRight from "../assets/corner/blue-sun-right.png";
import orangeLeft from "../assets/corner/orange-shape-left.png";
import orangeRight from "../assets/corner/orange-shape-right.png";
import pinkSunLeft from "../assets/corner/pink-sun-left.png";
import pinkSunRight from "../assets/corner/pink-sun-right.png";
import pinkShapeLeft from "../assets/corner/pink-shape-left.png";
import pinkShapeRight from "../assets/corner/pink-shape-right.png";

const Modal = ({ onClose, title, content, icon, index, category }) => {
  const isEven = index % 2 === 0;

  let topCornerIcon, bottomCornerIcon;
  let topCornerClass, bottomCornerClass;

  if (category === "strategy") {
    if (isEven) {
      topCornerIcon = orangeRight;
      topCornerClass = "top-right";
      bottomCornerIcon = orangeLeft;
      bottomCornerClass = "bottom-left";
    } else {
      topCornerIcon = blueSunLeft;
      topCornerClass = "top-left";
      bottomCornerIcon = blueSunRight;
      bottomCornerClass = "bottom-right";
    }
  } else if (category === "visual") {
    if (isEven) {
      topCornerIcon = pinkSunLeft;
      topCornerClass = "top-left";
      bottomCornerIcon = pinkSunRight;
      bottomCornerClass = "bottom-right";
    } else {
      topCornerIcon = pinkShapeRight;
      topCornerClass = "top-right";
      bottomCornerIcon = pinkShapeLeft;
      bottomCornerClass = "bottom-left";
    }
  }

  const boxClass = `modal-box ${topCornerIcon ? "extra-padding-top" : ""} ${
    bottomCornerIcon ? "extra-padding-bottom" : ""
  }`.trim();

  const renderContent = () => {
    if (typeof content === "string") {
      return <div className="modal-content" dangerouslySetInnerHTML={{ __html: content }} />;
    }
    return <div className="modal-content">{content}</div>;
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className={boxClass} onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>×</button>

        {/* Corner Icons */}
        {topCornerIcon && <img src={topCornerIcon} alt="" className={`corner-icon ${topCornerClass}`} />}
        {bottomCornerIcon && <img src={bottomCornerIcon} alt="" className={`corner-icon ${bottomCornerClass}`} />}

        {/* Scrollable */}
        <div className="modal-scrollable-content">
          <div className="modal-header">
            {icon ? (
              <img
                src={icon}
                alt=""
                className="modal-title-icon"
                onError={(e) => { e.currentTarget.style.display = "none"; }}
              />
            ) : null}
            <h2 className="modal-title">{title}</h2>
          </div>

          {renderContent()}
        </div>
      </div>
    </div>
  );
};

export default Modal;
